<template>
  <a class="app-link-open" rel="noopener noreferrer" target="_blank"
     :href="url">{{ name ? name : url }}<span class="sr-only">(opens in a new window or tab)</span></a>
</template>

<script>
export default {
  name: "BaseLinkOpenNew",
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    }
  }
}
</script>
